var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9077 6.15897L7.40768 9.65727C7.29102 9.77388 7.17435 9.83219 6.99935 9.83219C6.82435 9.83219 6.70768 9.77388 6.59102 9.65727L3.09102 6.15897C2.85768 5.92575 2.85768 5.57592 3.09102 5.3427C3.32435 5.10948 3.67435 5.10948 3.90768 5.3427L6.99935 8.43287L10.091 5.3427C10.3244 5.10948 10.6744 5.10948 10.9077 5.3427C11.141 5.57592 11.141 5.92575 10.9077 6.15897Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_863_4923",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 5,
    width: 10,
    height: 5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9077 6.15897L7.40768 9.65727C7.29102 9.77388 7.17435 9.83219 6.99935 9.83219C6.82435 9.83219 6.70768 9.77388 6.59102 9.65727L3.09102 6.15897C2.85768 5.92575 2.85768 5.57592 3.09102 5.3427C3.32435 5.10948 3.67435 5.10948 3.90768 5.3427L6.99935 8.43287L10.091 5.3427C10.3244 5.10948 10.6744 5.10948 10.9077 5.3427C11.141 5.57592 11.141 5.92575 10.9077 6.15897Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_863_4923)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.503387,
    width: 14,
    height: 13.9932,
    fill: "#161616"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow-icon.4ecd0581aca93e37641db694362eb663.svg";
export { ForwardRef as ReactComponent };